export enum ViewChangeType {
  UPDATE_LAYOUT_TYPE = 'UPDATE_LAYOUT_TYPE',
  UPDATE_LAYOUT_CARD_WIDTH = 'UPDATE_LAYOUT_CARD_WIDTH',
  UPDATE_LAYOUT_COVER_FIELD_ID = 'UPDATE_LAYOUT_COVER_FIELD_ID',
  UPDATE_LAYOUT_SHOW_FIELD_NAMES = 'UPDATE_LAYOUT_SHOW_FIELD_NAMES',
  UPDATE_LAYOUT_GROUP_FIELD_ID = 'UPDATE_LAYOUT_GROUP_FIELD_ID',
  SET_GROUPING_FIELD = 'SET_GROUPING_FIELD',
  SET_GROUPING_SORT_TYPE = 'SET_GROUPING_SORT_TYPE',
  SET_GROUPING_MANUAL_GROUP_ORDER = 'SET_GROUPING_MANUAL_GROUP_ORDER',
  CLEAR_GROUPING = 'CLEAR_GROUPING',
  UPDATE_LAYOUT_DATE_FIELD_ID = 'UPDATE_LAYOUT_DATE_FIELD_ID',
  UPDATE_NAME = 'UPDATE_NAME',
  UPDATE_FIELDS = 'UPDATE_FIELDS',
  UPDATE_SORT = 'UPDATE_SORT',
  UPDATE_SORT_VALUE = 'UPDATE_SORT_VALUE',
  INSERT_SORT = 'INSERT_SORT',
  APPEND_SORT = 'APPEND_SORT',
  DELETE_SORT = 'DELETE_SORT',
  REORDER_SORT = 'REORDER_SORT',
  CLEAR_SORT = 'CLEAR_SORT',
  SET_FILTER_USAGE_TYPE = 'SET_FILTER_USAGE_TYPE',
  SET_FILTER_VALUE = 'SET_FILTER_VALUE',
  SET_FILTER = 'SET_FILTER',
  APPEND_FILTER = 'APPEND_FILTER',
  REMOVE_FILTER = 'REMOVE_FILTER',
  CLEAR_FILTER = 'CLEAR_FILTER',
  SET_CALCULATIONS = 'SET_CALCULATIONS',
  REMOVE_CALCULATION = 'REMOVE_CALCULATION',
  UPDATE_LAYOUT_SHOW_NUMBERED_ENTRIES = 'UPDATE_LAYOUT_SHOW_NUMBERED_ENTRIES',
  /**
   * Replaces the entire properties bag on a view.
   */
  SET_PROPERTIES = 'SET_PROPERTIES',
  /**
   * Patches individual keys in a view's properties.
   */
  UPDATE_PROPERTIES = 'UPDATE_PROPERTIES',
}
